
define('text!modules/campaign/siteList/templates/bin_item.html',[],function () { return '<div class="detail name site-list-name">\n\t<div class="item-c icon {{#isAllowList}}include{{/isAllowList}}{{#isBlockList}}exclude{{/isBlockList}} active" data-action="include"></div>\n\t<div class="item-c text" title="{{full_path}}">{{full_path_end}}</div>\n</div>';});

